import script from "./warning.vue?vue&type=script&setup=true&lang=js"
export * from "./warning.vue?vue&type=script&setup=true&lang=js"

import "./warning.vue?vue&type=style&index=0&id=6df37e68&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6df37e68"]])

export default __exports__